import * as types from '../actionTypes/PLCCBannerActionTypes';

function PLCCBannerReducer(state = {}, action = {}) {
    switch (action.type) {
        case types.PLCC_BANNER_SUCCESS: {
            const { response } = action;
            return { ...state, response };
        }

        case types.PLCC_BANNER_ERROR: {
            const { error } = action;
            return { ...state, response: {}, error };
        }

        case types.CLEAR_PLCC_BANNER_DETAILS: {
            return { ...state, response: {}, error: null };
        }

        default:
            return state;
    }
}

PLCCBannerReducer.reducerName = 'plccBannerDetails';
export default PLCCBannerReducer;
